import { useQuery } from '@apollo/react-hooks'
import React, { useContext, useEffect, useState } from 'react'
import { GET_SP_BROKER } from './graphql/Queries'
import Loader from 'components/loaders/Loader'
import Page404 from 'components/Page404'
import { Avatar, Button, List } from 'antd'
// import BrokerModal from './BrokerModal'
import './index.css'
import { AppContext } from 'AppContext'
const AddBroker = () => {
  const {
    state: { currentUser },
  } = useContext(AppContext)
  const [showBrokerModal, setShowBrokerModal] = useState(false)
  const { data, loading, error, refetch } = useQuery(GET_SP_BROKER)

  useEffect(() => {
    refetch()
    // eslint-disable-next-line
  }, [])

  const showAddBrokerModal = () => {
    setShowBrokerModal(true)
  }
  if (loading) return <Loader />
  if (error) return <Page404 />
  return (
    <>
      {/* {showBrokerModal && (
        <BrokerModal setVisible={setShowBrokerModal} refetch={refetch} />
      )} */}
      {showBrokerModal &&
        (window.location.href = `${process.env.REACT_APP_BROKER_URL}/AdminSite/Pages/registrationForm.aspx?clientcode=${currentUser?.clientCode}&usercode=${currentUser?.userName}`)}
      <div className='main_display_div pending_advisory_div'>
        <div className='add_broker_container_Popover' style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-end' }}>
          <Button 
            onClick={() => showAddBrokerModal()}
            style={{ 
              borderRadius: '4px',
              fontWeight: '600',
              borderColor: '#d9d9d9',
              boxShadow: '0 2px 0 rgba(0,0,0,0.015)'
            }}
          >
            {data?.spGetBroker[0]?.length > 0
              ? 'Update/Change Broker'
              : 'Add Broker'}
          </Button>
        </div>
        <div>
          {!data?.spGetBroker[0]?.length > 0 ? (
            <p className='add_broker_header_container'>No Broker Mapped</p>
          ) : (
          <div className="broker-mapping-content">
            <List itemLayout='horizontal'>
              <List.Item 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  background: '#ffffff',
                  padding: '20px',
                  borderRadius: '12px',
                  border: '1px solid #f0f0f0',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                }}
              >
                <List.Item.Meta
                  avatar={<Avatar size={54} style={{ backgroundColor: '#AF0000', fontSize: '20px', fontWeight: 'bold' }}>{data?.spGetBroker[0][0]?.Broker?.charAt(0)}</Avatar>}
                  title={
                    <div style={{ marginBottom: '4px' }}>
                      <span style={{ fontSize: '18px', fontWeight: '700', color: '#262626' }}>
                        {data?.spGetBroker[0][0]?.Broker}
                      </span>
                    </div>
                  }
                  description={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span style={{ color: '#595959', fontWeight: '500', marginRight: '8px' }}>Public IP:</span>
                      <span style={{ fontWeight: '600', color: '#AF0000', fontSize: '15px' }}>
                        {data?.spGetBroker[0][0]?.PublicIP}
                      </span>
                    </div>
                  }
                />
              </List.Item>
            </List>
          </div>
          )}
        </div>
      </div>
    </>
  )
}

export default AddBroker
